import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { MDBIcon, MDBView } from "mdbreact";
import {
  RESET,
  BROWSE,
  SetMONTH,
} from "../../../../../services/redux/slices/finance/journals/payments";
import CalendarPicker from "../../../../../components/header/calendars";
import { currency } from "../../../../../services/utilities";

export default function TopHeader({ setShow = () => {} }) {
  const { token, activePlatform } = useSelector(({ auth }) => auth),
    { month, year, collections } = useSelector(({ payments }) => payments),
    [total, setTotal] = useState(0),
    dispatch = useDispatch();

  useEffect(() => {
    if (token && activePlatform?.branchId && year && month) {
      dispatch(
        BROWSE({
          token,
          key: {
            branchId: activePlatform?.branchId,
            year,
            month,
          },
        })
      );
    }
    // return () => dispatch(RESET());
  }, [token, activePlatform, year, month, dispatch]);
  useEffect(() => {
    if (collections.length > 0) {
      const total = collections.reduce((acc, payment) => {
        return acc + payment?.amount || 0;
      }, 0);
      setTotal(total);
    } else {
      setTotal(0);
    }
  }, [collections]);

  return (
    <MDBView
      cascade
      className="gradient-card-header blue-gradient narrower py-2 mx-4 mb-3 d-flex justify-content-between align-items-center"
    >
      <div className="d-flex justify-items-center">
        <CalendarPicker
          month={month}
          year={year}
          moved={(next) => dispatch(SetMONTH(next))}
          reset={() => dispatch(RESET())}
        />
      </div>
      <div>
        <span className="white-text  text-nowrap mt-0 mr-2">
          PAYMENTS ({currency.format(total)}){" "}
        </span>
        <button
          onClick={() => setShow(true)}
          size="sm"
          // color="white"
          className="search-add-btn ml-2"
        >
          <MDBIcon icon="plus" title="Petty Cash Vouchers" />
        </button>
      </div>
    </MDBView>
  );
}
